// Styles
import 'vuetify/styles';
// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { aliases, mdi } from 'vuetify/iconsets/mdi'
import i18n from '../i18n';

import * as labs from 'vuetify/labs/components'

const vuetify = createVuetify({
    components: {
        ...labs,
        ...components,
        ...directives

    },
    breakpoint: {
        scrollBarWidth: 16,
        thresholds: {
            xs: 576,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 1400,
        },
    },
    rtl: false,
    defaults: {
        // Vuetify houdt een tooltip 12px van de schermrand, maar een dialog
        // staat op mobiel 16px van de rand: de tooltip stak er dan buiten
        // (ClickUp 86c4g6j4n). Met 24px valt hij binnen de witte kaart.
        VTooltip: {
            viewportMargin: 24,
        },
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    },
    locale: {
        locale: i18n.locale ?? 'nl', // optional Vuetify i18n locale
    },
    theme: {
        options: {
            customProperties: true
        },
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: 'var(--company-primary)',
                    secondary: '#403E48',
                    bluecool200: '#D9D8DA',
                    fireaxered100: '#FBFAFB',
                    neutral100: '#F5F5F5',
                    error: '#E50039',
                    warning: '#FFCC26',
                },
            },
            dark: {
                colors: {
                    primary: '#F24139',
                    secondary: '#403E48',
                    bluecool200: '#D9D8DA',
                    fireaxered100: '#FBFAFB',
                    neutral100: '#F5F5F5',
                    error: '#E50039',
                    warning: '#FFCC26',
                },
            },

        },

    }
});

export default vuetify;